import Vue from 'vue'

const eventBus = new Vue()

const topic = {
  publish(topic, ...event) {
    eventBus.$emit(topic, ...event)
  },
  subscribe(topic, listener) {
    eventBus.$on(topic, listener)
  },
  unsubscribe(topic, listener) {
    if (listener === undefined) {
      eventBus.$off(topic)
    } else {
      eventBus.$off(topic, listener)
    }
  }
}

export default topic
